export const ChevronLeft = () => (
  <svg
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    className="u-icon u-icon--utility-chevron-left"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.03972 8.10131C3.82004 7.88164 3.82004 7.52553 4.03972 7.30586L9.77459 1.571C9.99427 1.35133 10.3504 1.35133 10.57 1.571L10.8352 1.83617C11.0549 2.05584 11.0549 2.41199 10.8352 2.63167L5.76329 7.70359L10.8352 12.7755C11.0549 12.9952 11.0549 13.3513 10.8352 13.571L10.57 13.8362C10.3504 14.0559 9.99427 14.0559 9.77459 13.8362L4.03972 8.10131Z"
      fill="currentColor"
    />
  </svg>
);
